import React, { useState } from "react";
import Table from "../../Common/Table";
import { useHistory } from "react-router-dom";
import TableFields from "../../../constants/Country/TableFields.json";
import { getPath, getReadableDateTime } from "../../../utils";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import SaveModal from "../../Common/SaveModal";

const CountryList = (props) => {
  const history = useHistory();
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const { countryList } = props;
  const [activeDeleteCountry, setActiveDeleteCountry] = useState({});
  const allActions = MenuActionsMappings[MenuNames.COUNTRY];

  const confirmModalOpenHandler = (countryObj) => {
    setActiveDeleteCountry(countryObj);
    setConfirmModalOpen(true);
  };

  const confirmModalCloseHandler = () => {
    setConfirmModalOpen(false);
    setActiveDeleteCountry({});
  };

  const deleteCountryHandler = () => {
    props.deleteCountry(activeDeleteCountry.id);
    confirmModalCloseHandler();
  };

  const getFieldValue = (country, key) => {
    switch (key) {
      case "actions":
        return (
          <Permission
            optionalPerms={[
              allActions.DETAIL,
              allActions.UPDATE,
              allActions.DELETE,
            ]}
            notAllowedText="No Permitted Actions"
          >
            <Permission optionalPerms={[allActions.DETAIL, allActions.UPDATE]}>
              <span
                onClick={() => history.push(`/countries/${country.id}`)}
                className={`edit-options cursor-pointer ${
                  allActions.DELETE && "mr-10"
                }`}
              >
                View/Edit
              </span>
            </Permission>
            <Permission requiredPerms={[allActions.DELETE]}>
              <span
                onClick={() => confirmModalOpenHandler(country)}
                className={"edit-options cursor-pointer"}
              >
                Delete
              </span>
            </Permission>
          </Permission>
        );
      case "created_at":
      case "updated_at":
        return getReadableDateTime(country[key]);
      default:
        return getPath(country, key, "NA");
    }
  };

  return [
    <Table
      list={countryList}
      getFieldValue={getFieldValue}
      fields={TableFields}
    />,
    <SaveModal
      isVisible={confirmModalOpen}
      handleSubmit={deleteCountryHandler}
      handleClose={confirmModalCloseHandler}
      heading="Delete Country"
      getMessage={() =>
        `Are you sure to delete ${activeDeleteCountry.country_name} country?`
      }
    />,
  ];
};

export default CountryList;
